import React, { memo } from "react";
import shortid from "shortid";
import { TableBody, TableCell, TableRow } from "@material-ui/core";

function TableBodyCustom({
  columns,
  data,
  marginBorder,
  ativarHoverLinha,
  hideBorderBottom = false
}) {  

  function renderCell(row, col) {
    const { dataIndex } = col;
    let value;

    if (typeof dataIndex === "string") {
      value = row[dataIndex];
    } else {
      dataIndex && dataIndex.map((d) => {
        if (value) return (value = value[d]);
        else return (value = row[d]);
      });
    }

    if (!value && value !== 0 && typeof value !== "boolean") value = "-";

    if (col.render) {
      return col.render(value, row);
    } else {
      return value;
    }
  }  

  return (
    <TableBody >
      {data && data.map((row) => {
        return (
          <TableRow
            hover={ativarHoverLinha}
            key={row.id || shortid.generate()}
            role="checkbox"
            tabIndex={-1}
          >
            <>
              {columns && columns.map((col, index) => (
                <TableCell                
                  key={shortid.generate()}
                  align={col.align || "left"}
                  style={{ minWidth: col.width || "auto", maxWidth: col.maxWidth || "auto",
                  borderBottom: hideBorderBottom ? 'none' : '1px solid lightgray',
                  borderLeft: (marginBorder && index === 0) ? '1px solid lightgray' : null,  
                  borderRight: (marginBorder && index === columns.length-1) ? '1px solid lightgray' : null, 
                }}
                >
                  {renderCell(row, col)}
                </TableCell>
              ))}
            </>
          </TableRow>
        );
      })}
    </TableBody>
  );
}

export default memo(TableBodyCustom);
